import { p as ApiError } from "./createFetchClient-DITkTV2k.js";
//#region src/errors/ManagementClientAuthError.ts
var ManagementClientAuthError = class extends ApiError {
	title;
	message;
	constructor(title, message, res) {
		super(res);
		this.name = "ManagementClientAuthError";
		this.title = title;
		this.message = message;
	}
};
//#endregion
export { ManagementClientAuthError as t };

//# sourceMappingURL=ManagementClientAuthError-BcPYxAWZ.js.map